export const TITLE_SOURCE_MR = "MR";
export const TITLE_SOURCE_MDM = "MME";

export const titleSourcesOption = {
  [TITLE_SOURCE_MR]: "MR",
  [TITLE_SOURCE_MDM]: "MME",
};
